export default __webpack_public_path__ + "static/media/grafema_gim-tonico_09.021c33d9.jpg";